import { Component, OnInit, OnDestroy } from '@angular/core';
import { PwaService } from '../../../core/services/pwa.service';
import { SettingsService } from '../../../core/services/settings.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-pwa-update-prompt',
  templateUrl: './pwa-update-prompt.component.html',
  styleUrls: ['./pwa-update-prompt.component.scss']
})
export class PwaUpdatePromptComponent implements OnInit, OnDestroy {
  showUpdatePrompt = false;
  companyName = 'Bilali Islamic Shopping';
  private destroy$ = new Subject<void>();

  constructor(
    private pwaService: PwaService,
    private settingsService: SettingsService
  ) {
    this.companyName = this.settingsService.getCompanyName();
  }

  ngOnInit(): void {
    this.pwaService.updateAvailable$
      .pipe(takeUntil(this.destroy$))
      .subscribe(updateAvailable => {
        this.showUpdatePrompt = updateAvailable;
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  update(): void {
    this.pwaService.activateUpdate();
  }

  dismiss(): void {
    this.showUpdatePrompt = false;
  }
}











